import { Button } from 'antd';
import React from 'react';
import styles from './ModalFooter.module.scss';
import cn from 'classnames';
import SaveDraft from '../SaveDraft/SaveDraft';

const ModalFooter = ({ form, onCancel, onSubmit, loading = false }) => (
  <div className={styles.root}>
    <SaveDraft
      form={form}
      onCancel={onCancel}
      disabled={loading}
      className={styles.saveBtn}
    />
    <div className={styles.innerWrap}>
      <Button
        onClick={onCancel}
        disabled={loading}
        className={styles.btnNormal}
      >
        Отмена
      </Button>
      <Button
        type="primary"
        onClick={onSubmit}
        loading={loading}
        className={cn(styles.btnPrimary, {
          [styles.submitBtnDisabled]: loading,
        })}
      >
        Создать
      </Button>
    </div>
  </div>
);

export default ModalFooter;
